import { formatDateTime } from '../lib/format';

/** Decision / audit trail, newest first. entries: [{ at, actor, action, from, to, reason }] */
export default function Trail({ entries, empty = 'No decisions yet.' }) {
  const rows = [...(entries || [])].reverse();
  if (!rows.length) return <p className="text-sm opacity-70">{empty}</p>;
  return (
    <ol className="space-y-3 border-l-2 border-[var(--app-border)] pl-4">
      {rows.map((e, i) => (
        <li key={`${e.at}-${i}`} className="text-sm">
          <div className="font-medium">
            {String(e.action).replace(/[._]/g, ' ')}
            {e.to && e.from !== e.to ? <span className="opacity-60 font-normal"> → {String(e.to).replace(/_/g, ' ')}</span> : null}
          </div>
          <div className="text-xs opacity-60">{e.actor} · {formatDateTime(e.at)}</div>
          {e.reason ? <div className="mt-1 text-sm opacity-90">“{e.reason}”</div> : null}
        </li>
      ))}
    </ol>
  );
}
